import { Project } from '@/shared/config/projects';
import { axiosInstance } from '@/shared/core';
import { projectAxios } from '@/shared/core/axios';

import {
  CreateAuthorDTO,
  GetAuthorResponseDTO,
  GetAuthorsResponseDTO,
  UpdateAuthorDTO,
} from './dto/authors.dto';

// export async function uploadAuthorPreview(
//   file: FileWithPath,
// ): Promise<string> {
//   const formData = new FormData();

//   formData.append('image', file);
//   return (
//     await axiosInstance.post<{ imagePath: string }>(
//       '/book/uploadImage',
//       formData,
//     )
//   ).data.imagePath;
// }

export async function createAuthor(
  project: Project,
  data: CreateAuthorDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.post('/authors', {
      name: data.name,
      bio: data.description || undefined,
      birthday: data.birthday || undefined,
    });
    return;
  }

  await axiosInstance.post('/author/create', {
    name: data.name,
    description: data.description,
  });
}

export async function getAuthor(
  project: Project,
  id: number,
): Promise<GetAuthorResponseDTO> {
  if (project === 'kitaba') {
    const author = (await projectAxios.kitaba.get(`/authors/${id}`)).data;
    return {
      id: author.id,
      name: author.name,
      description: author.bio ?? null,
      birthday: author.birthday ?? null,
    };
  }

  return (
    await axiosInstance.get('/author/get', {
      params: {
        authorId: id,
      },
    })
  ).data;
}

export async function getAuthors(
  project: Project,
): Promise<GetAuthorsResponseDTO> {
  if (project === 'kitaba') {
    const response = (await projectAxios.kitaba.get('/authors')).data;
    return {
      authors: response.authors.map(
        (author: {
          id: number;
          name: string;
          bio?: string;
          birthday?: string;
        }) => ({
          id: author.id,
          name: author.name,
          description: author.bio ?? null,
          birthday: author.birthday ?? null,
        }),
      ),
    };
  }

  return (await axiosInstance.get('/author/getAll')).data;
}

export async function updateAuthor(
  project: Project,
  data: UpdateAuthorDTO,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.patch(`/authors/${data.id}`, {
      name: data.name,
      bio: data.description,
      birthday: data.birthday || undefined,
    });
    return;
  }

  await axiosInstance.post('/author/update', {
    id: data.id,
    name: data.name,
    description: data.description,
  });
}

export async function deleteAuthor(
  project: Project,
  id: number,
): Promise<void> {
  if (project === 'kitaba') {
    await projectAxios.kitaba.delete(`/authors/${id}`);
    return;
  }

  await axiosInstance.post('/author/delete', {
    id,
  });
}
